module.exports = __webpack_public_path__ + "static/media/scenario-edit.1b81664a.png";